import { RankCard } from "./RankCard";
import type { BaseListItem } from "@/types";

type RankItem = BaseListItem & { rank: number };

function extractAppId(value: unknown): number | null {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string" && value.trim()) {
    const n = Number.parseInt(value, 10);
    return Number.isFinite(n) ? n : null;
  }
  if (value && typeof value === "object" && "appid" in value) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return extractAppId((value as any).appid);
  }
  return null;
}

interface RankCardsProps<T extends RankItem> {
  items: T[];
  onCardClick: (appid: number) => void;
  primaryColor: string;
}

export function RankCards<T extends RankItem>({
  items,
  onCardClick,
  primaryColor,
}: RankCardsProps<T>) {
  return (
    <div className="md:hidden">
      {items.map((item, idx) => {
        const appid = extractAppId(item.appid);
        const key = appid ?? `fallback-${item.rank}-${idx}`;
        return (
        <RankCard
          key={key}
          item={item}
          onCardClick={(id) => {
            if (appid == null) return;
            onCardClick(id);
          }}
          primaryColor={primaryColor}
        />
        );
      })}
    </div>
  );
}

